import useAuthStore from "./stores/useAuthStore";
export default {
    install(Vue) {
        Vue.mixin(useAuthStore)
    }
}
